import React from 'react';
import FormTitle from '../FormTitle';
import StepCustomersList from '../StepCustomersList';
import FormCreateShuma from '../FormCreateShuma';
import styles from './styles.module.scss';

const Form_13View = ({shumaID}) => {
  return (
    <div>
      <FormTitle title={'מידע כללי'}/>
      <div className={styles.form_13}>
        <StepCustomersList shumaID={shumaID}/>
        <FormCreateShuma/>
      </div>
    </div>
  );
};

export default Form_13View;
